import { Package } from "./Package";

export enum ParcelPopinMode {
  READ,
  EDIT,
  CREATE,
}

export type PageConfig = {
  [key in ParcelPopinMode]: {
    title: string;
    displayDeleteButton: boolean;
    displaySubmitButton: boolean;
    cancelButtonText: string;
  };
};

export type Parcel = {
  id: string;
  createdAt: Date | string;
  opId: string;
  height?: number;
  weight: number;
  quantity: number;
  loadingMeters: number;
  packages: Package[];
};
